import { AlertNotification } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const DateOfBirthToast = ({ onClose }) => {
  const { t } = useI18n();

  return (
    <AlertNotification
      type="error"
      message={t('web.registration.validation.date_of_birth')}
      classNames={{ messageClassName: styles.fixed }}
      onClose={onClose}
      breed="B"
    />
  );
};
